<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/serviceIndex' }"
          >客户服务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/resourceIndex/rServiceDetail'}"
          >客户详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>触达记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>添加客户触达记录</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>最近联系情况</p>
            <div class="select_box">
              <el-select
                v-model="formData.getstate"
                placeholder="请选择最近联系情况"
                @visible-change="getQywxset('contactresult')"
                :disabled="idc != 0"
              >
                <el-option
                  v-for="item in linkConditionOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>联系形式</p>
            <div class="select_box">
              <el-select
                v-model="formData.gettype"
                placeholder="请选择联系形式"
                @visible-change="getQywxset('linktype')"
                :disabled="idc != 0"
              >
                <el-option
                  v-for="item in linkTypeOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>联系结果</p>
            <div class="select_box">
              <el-select
                v-model="formData.result"
                placeholder="请选择联系结果"
                @visible-change="getQywxset('linkresult')"
                :disabled="idc != 0"
              >
                <el-option
                  v-for="item in linkResultOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>情况说明：</p>
            <div class="input_box">
              <el-input
                v-model="formData.details"
                placeholder="请输入情况说明"
                type="textarea"
                :readonly="idc != 0"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>客户名称：</h1>
            <p>
              {{
                customerDetail.info_truename
                  ? customerDetail.info_truename
                  : customerDetail.ext_name
              }}
            </p>
          </div>
          <div class="item">
            <h1>企业名称：</h1>
            <div class="flex-rowl">
              <p v-if="customerDetail.other_companystr">
                {{ customerDetail.other_companystr }}
              </p>
              <div class="edit_wrap flex-rowl">
                <div class="check_box">
                  <el-checkbox v-model="isEditCompany" :disabled="idc != 0">是否变更</el-checkbox>
                </div>
                <div class="select_box" v-if="isEditCompany">
                  <el-select
                    v-model="formData.other_company"
                    placeholder="输入企业名称"
                    @visible-change="getCustomQyList"
                  >
                    <el-option
                      v-for="item in customerQy"
                      :key="item.id"
                      :label="item.bodyname"
                      :value="item.bodyqyguid"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <h1>职务：</h1>
            <div class="flex-rowl">
              <p v-if="customerDetail.other_job">
                {{ customerDetail.other_job }}
              </p>
              <div class="edit_wrap flex-rowl">
                <div class="check_box">
                  <el-checkbox v-model="isEditJob" :disabled="idc != 0">是否变更</el-checkbox>
                </div>
                <div class="input_box" v-if="isEditJob">
                  <el-input
                    v-model="formData.other_job"
                    placeholder="输入职务"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <h1>联系方式：</h1>
            <div class="flex-rowl">
              <p v-if="customerDetail.info_mobile">
                {{ customerDetail.info_mobile }}
              </p>
              <div class="edit_wrap flex-rowl">
                <div class="check_box">
                  <el-checkbox v-model="isEditMobile" :disabled="idc != 0">是否变更</el-checkbox>
                </div>
                <div class="input_box" v-if="isEditMobile">
                  <el-input
                    v-model="formData.mobile"
                    placeholder="输入联系方式"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query" v-if="idc == 0">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>
<script>
import {
  getQywxset,
  getCustomerDetail,
  getCustomerGenDetail,
  editCustomerGen,
  addCustomerGen,
  encryptstringview,
} from "../../../api/api";
import { getCustomQyList } from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "rServiceAddRecord",
  data() {
    return {
      id: "",
      idc: "",
      qyguid: "",
      loading: false,
      formData: {
        openid: this.$store.state.OPENID,
        customerid: "",
        // createdate: "",
        getstate: "",
        gettype: "",
        result: "",
        details: "",
        others: "",
        mobile: "",
        other_company: "",
        other_job: "",
      },
      customerDetail: "", // 客户详情

      linkConditionOption: [], // 联系情况
      linkTypeOption: [], // 联系形式
      linkResultOption: [], // 联系结果
      customerQy: [], // 企业

      isEditCompany: false, // 是否修改企业
      isEditJob: false, // 是否修改职务
      isEditMobile: false, // 是否修改联系方式
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    // let now = new Date();
    // let year = now.getFullYear();
    // let month = now.getMonth() + 1;
    // let date = now.getDate();
    // this.formData.createdate = year + "/" + month + "/" + date;

    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyguid = USERINFO.qy.qyguid;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, idC } = JSON.parse(res.jsondata);
        this.id = id;
        this.idc = idC;

        this.formData.customerid = id;
        this.getQywxset("contactresult");
        this.getQywxset("linktype");
        this.getQywxset("linkresult");
        this.getCustomerDetail();
        if (idC != 0) {
          this.getCustomerGenDetail();
        }
      } else {
        this.$router.back();
      }
    },

    // 获取触达详情
    getCustomerGenDetail() {
      getCustomerGenDetail({ id: this.idc }).then((res) => {
        this.formData.customerid = res.customerid;
        this.formData.id = res.id;
        this.formData.getstate = res.getstate;
        this.formData.gettype = res.gettype;
        this.formData.result = res.result;
        this.formData.details = res.details;
        this.formData.others = res.others;
        this.formData.other_company = res.other_company;
        this.formData.other_job = res.other_job;
        this.formData.mobile = res.mobile;
      });
    },
    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        console.log(res, "======");
        this.customerDetail = res;
      });
    },
    getCustomQyList() {
      getCustomQyList({ qyguid: this.qyguid }).then((res) => {
        this.customerQy = res.list;
      });
    },

    getQywxset(value) {
      getQywxset(value).then((res) => {
        if (value == "contactresult") {
          this.linkConditionOption = res;
        } else if (value == "linktype") {
          this.linkTypeOption = res;
        } else if (value == "linkresult") {
          this.linkResultOption = res;
        }
      });
    },
    query() {
      let { formData, idc } = this;
      console.log(formData,'===-==formData');
      if (formData.getstate == "") {
        this.$message.warning("请输入最近联系情况 ");
        return;
      }
      if (formData.gettype == "") {
        this.$message.warning("请输入联系形式");
        return;
      }
      if (formData.result == "") {
        this.$message.warning("请输入联系结果");
        return;
      }
      if (formData.details == "") {
        this.$message.warning("请输入情况说明");
        return;
      }
      if (idc == 0) {
        this.addCustomerGen();
      } else {
        this.editCustomerGen();
      }
    },

    // 修改
    editCustomerGen() {
      this.loading = true;
      editCustomerGen(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 新增
    addCustomerGen() {
      this.loading = true;
      addCustomerGen(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
            margin-right: 20px;
          }
          .edit_wrap {
            height: 30px;
            .check_box {
              margin-right: 20px;
            }
            .select_box,
            .input_box {
              width: 200px;
            }
          }
        }
      }
    }
  }
  /deep/.el-checkbox.is-disabled .el-checkbox__label {
    color: #999; /* 例如，改变标签颜色为灰色 */
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #999; /* 例如，改变标签颜色为灰色 */
  }
}
</style>